import { ServiceOSEmailVerificationProps } from './ServiceOSEmailVerification.types';
import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import { getServiceOSEmailVerificationQueryParams } from '../../utils/getServiceOSEmailVerificationQueryParams';
import styled from 'styled-components';
import { ServiceOSApiClient } from '../../utils/serviceOSApiClient';
import { useGlobalProviderContext } from '../../context/global';
import { StoryblokComponent } from '@storyblok/react';
import { patchedStoryblokEditable } from '../../utils/patchedStoryblokEditable';

const DEFAULT_LOADING_TEXT = 'Loading...';

const Wrapper = styled.div`
  font-size: 20px;
  padding: 20px;
`;

const serviceOSApiClient = new ServiceOSApiClient();

export const ServiceOSEmailVerification = (props: ServiceOSEmailVerificationProps) => {
  const { blok } = props;
  const {
    loadingText,
    showResponseMessageFromServiceOS,
    onErrorMessage,
    redirectOnError,
    redirectOnErrorTimeoutSeconds,
    redirectOnErrorTo,
  } = blok;

  const [serviceOSResponseMessage, setServiceOSResponseMessage] = useState<string | null>(null);
  const [isServiceOSError, setIsServiceOSError] = useState<boolean>(false);
  const [serviceOSLoading, setServiceOSLoading] = useState<boolean>(false);

  const redirectTimerRef = useRef(null);
  const router = useRouter();
  const globalContext = useGlobalProviderContext();

  const verifyEmailAndGenerateFountainLink = async (email: string, verificationToken: string) => {
    setServiceOSLoading(true);

    const { successMessage, errorMessage } = await serviceOSApiClient.verifyEmail(
      email,
      verificationToken
    );

    setServiceOSLoading(false);

    setServiceOSResponseMessage(successMessage || errorMessage);

    if (successMessage) {
      const { data, successMessage, errorMessage } =
        await serviceOSApiClient.generateFountainLink();

      setServiceOSResponseMessage(successMessage || errorMessage);

      if (errorMessage) {
        setIsServiceOSError(true);
        return;
      }

      window.location = data?.portal_url;
    } else {
      setIsServiceOSError(true);
    }
  };

  useEffect(() => {
    const {
      values: { email, verificationToken },
    } = getServiceOSEmailVerificationQueryParams(globalContext.serviceOSSettings);

    if (email && verificationToken) {
      void verifyEmailAndGenerateFountainLink(email, verificationToken);
    } else {
      router.push(`/${router.locale}`);
    }
  }, []);

  useEffect(() => {
    if (isServiceOSError && redirectOnError && redirectOnErrorTo && redirectOnErrorTimeoutSeconds) {
      if (redirectTimerRef.current) {
        clearTimeout(redirectTimerRef.current);
        redirectTimerRef.current = null;
      }

      redirectTimerRef.current = setTimeout(() => {
        router.push(redirectOnErrorTo.cached_url || redirectOnErrorTo.url);
      }, Number(redirectOnErrorTimeoutSeconds));
    }
  }, [isServiceOSError]);

  return (
    <Wrapper {...patchedStoryblokEditable(blok)}>
      <div>
        {serviceOSLoading &&
          (!!loadingText.length ? (
            <StoryblokComponent blok={loadingText[0]} />
          ) : (
            DEFAULT_LOADING_TEXT
          ))}
        {!serviceOSLoading && (showResponseMessageFromServiceOS ? serviceOSResponseMessage : null)}
      </div>
      <br />
      {!!onErrorMessage.length && isServiceOSError && (
        <div>
          <StoryblokComponent blok={onErrorMessage[0]} />
        </div>
      )}
    </Wrapper>
  );
};
